module.exports = __webpack_public_path__ + "img/icon_mini_print.3bf6b9f7.svg";